<template>
  <div class='h-dialogContainer'>
    <form id='addDpNode'>
      <!--<div class='row h-row-inputBox'>
       &lt;!&ndash; <div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'>{{this.$t('DeployManagement.nodeID')}}</div>
            <input type="text" name="nodeId" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="nodeId" :disabled="disabled">
          </div>
        </div>&ndash;&gt;
        <div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'>{{this.$t('DeployManagement.nodeType')}}</div>
            <ejs-dropdownlist id="nodeType" :dataSource = "nodeTypeItems" :popupHeight= "popupHeight" v-model='nodeType' :readonly="disabled">
            </ejs-dropdownlist>
          </div>
        </div>
      </div>-->
      <div class='row h-row-inputBox'>
        <!--<div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'>{{this.$t('DeployManagement.nodeIP')}}</div>
            <input type="text" name="nodeIP" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="nodeIP" :disabled="disabled">
          </div>
        </div>-->
        <div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('DeployManagement.nodeName')}}</div>
            <input type="text" name="nodeName" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="nodeName" :disabled="disabled">
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('DeployManagement.nodeType')}}</div>
            <ejs-dropdownlist id="nodeType" :dataSource = "nodeTypeItems" :popupHeight= "popupHeight" v-model='nodeType' :readonly="disabled">
            </ejs-dropdownlist>
          </div>
        </div>
      </div>
      <div class='row h-row-inputBox'>
        <!--<div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'>节点Port</div>
            <input type="text" name="nodePort" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="nodePort" :disabled="disabled">
          </div>
        </div>-->

        <div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'>{{this.$t('DeployManagement.nodeDesc')}}</div>
            <input type="text" name="nodeDesc" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="nodeDesc" :disabled="disabled">
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('DeployManagement.displaySoftWareVersion')}}</div>
            <input type="text" name="displaySoftWareVersion" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="displaySoftWareVersion" :disabled="true">
          </div>
        </div>
      </div>
      <!--<div class='row h-row-inputBox'>
        <div class='col-sm-12 h-col-inputBox'>
          <div>
            <div class='h-inputLit'>节点备注</div>
            <input type="text" name="nodeDesc" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="nodeDesc">
          </div>
        </div>
      </div>-->
      <div class="h-borderBox h-subscriber-parseList">
        <div class="h-dialog-borderBox-topIcon">{{this.$t('DeployManagement.configParams')}}
          <div class="h-toolbarBg dialog-icon-style">

          </div>
        </div>
      </div>
      <div class="h-borderBox-content" style="margin-top: 10px">
        <!--<div class='row h-row-inputBox'>
          <div class='col-sm-6 h-col-inputBox'>
            <div>
              <div class='h-inputLit'>{{this.$t('DeployManagement.userName')}}</div>
              <input type="text" name="userName" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="userName">
            </div>
          </div>
          <div class='col-sm-6 h-col-inputBox'>
            <div>
              <div class='h-inputLit'>{{this.$t('DeployManagement.password')}}</div>
              <input type="text" name="password" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="password">
            </div>
          </div>
        </div>-->
        <div class='row h-row-inputBox'>
          <div class='col-sm-6 h-col-inputBox'>
            <div>
              <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('DeployManagement.internalIP')}}</div>
              <input type="text" name="internalIP" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="internalIP">
            </div>
          </div>
          <div class='col-sm-6 h-col-inputBox'>
            <div>
              <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('DeployManagement.sysExternalIp')}}</div>
              <input type="text" name="sysExternalIp" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="sysExternalIp">
            </div>
          </div>
        </div>
        <div class='row h-row-inputBox'>
          <div class='col-sm-12 h-col-inputBox'>
            <div>
              <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('DeployManagement.installPkgPath')}}</div>
              <input type="text" name="installPkgPath" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model="installPkgPath">
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Vue from 'vue';
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { FormValidator } from '@syncfusion/ej2-vue-inputs';

Vue.use(TextBoxPlugin);
export default {
  name: 'AddDPNode',
  props: [

  ],
  components: {
  },
  data() {
    return {
      nodeId: '',
      nodeType: 'Master',
      displaySoftWareVersion: '',
      nodeIP: '',
      nodePort: '',
      nodeName: '',
      nodeDesc: '',
      userName: '',
      password: '',
      internalIP: '',
      sysExternalIp: '',
      installPkgPath: '',
      disabled: false,
      popupHeight: 200,
      nodeTypeItems: [
        { text: 'Master', value: 'Master' },
        { text: 'Node', value: 'Node' }
      ],
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.float = 'left';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          /*nodeId: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
            regex: [/^(^\S)/, `${this.$t('DeployManagement.noEmptyStart')}`],
            maxLength: [30, `${this.$t('DeployManagement.topoMaxLength')}30`],
          },*/
          nodeName: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
            regex: [/^(^\S)/, `${this.$t('DeployManagement.noEmptyStart')}`],
            maxLength: [100, `${this.$t('DeployManagement.topoMaxLength')}100`],
          },
          nodeDesc: {
            // required: [true, `${this.$t('DeployManagement.alertRequired')}`],
            regex: [/^(^\S)/, `${this.$t('DeployManagement.noEmptyStart')}`],
            maxLength: [200, `${this.$t('DeployManagement.topoMaxLength')}200`],
          },
          installPkgPath: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
            regex: [/^(^\S)/, `${this.$t('DeployManagement.noEmptyStart')}`],
            maxLength: [100, `${this.$t('DeployManagement.topoMaxLength')}100`],
          },
          /*nodeIP: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
            regex: ['^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$', `${this.$t('Topo.invalidIPAddress')}`],
          },*/
          /*nodePort: {
            required: [true, `${this.$t('Pm.alertRequired')}`],
            regex: ['^\\d*$', `${this.$t('Topo.invalidInt')}`],
            range: [[1, 65535], `${this.$t('Topo.inputRangeIllegal')}`],
          },*/
          /*userName: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
            regex: [/^(^\S)/, `${this.$t('DeployManagement.noEmptyStart')}`],
            maxLength: [30, `${this.$t('DeployManagement.topoMaxLength')}30`],
          },
          password: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
            regex: [/^(^\S)/, `${this.$t('DeployManagement.noEmptyStart')}`],
            maxLength: [30, `${this.$t('DeployManagement.topoMaxLength')}30`],
          },*/
          internalIP: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
            regex: ['^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$', `${this.$t('Topo.invalidIPAddress')}`],
          },
          sysExternalIp: {
            required: [true, `${this.$t('DeployManagement.alertRequired')}`],
            regex: ['^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$', `${this.$t('Topo.invalidIPAddress')}`],
          }
        }
      }
    };
  },
  methods: {
    getData() {
      return {
        id: this.nodeId,
        name: this.nodeName,
        type: this.nodeType,
        desc: this.nodeDesc,
        ip: this.nodeIP,
        port: this.nodePort,
        version: this.displaySoftWareVersion,
        deployParams: [{"k8s":[{"field_code":"INSTALL_PKG_PATH","field_value": this.installPkgPath},{"field_code":"INTERNAL_IP","field_value": this.internalIP},{"field_code":"SYS_EXTERNAL_IP","field_value": this.sysExternalIp},{"field_code":"USERNAME","field_value": this.userName},{"field_code":"PASSWORD","field_value": this.password}]}]
      };
    },
    bindValidate() {
      this.formObj = new FormValidator('#addDpNode', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    },
    setValue(record, pms) {
      this.disabled = true;
      this.nodeId = record.k8sNodeId;
      this.nodeName = record.name;
      this.nodeType = record.service;
      this.nodeDesc = record.description;
      this.displaySoftWareVersion = record.displaySoftWareVersion;
      this.nodeIP = record.ip;
      this.nodePort = record.port;

      this.userName = pms.USERNAME;
      this.password = pms.PASSWORD;
      this.internalIP = pms.INTERNAL_IP;
      this.sysExternalIp = pms.SYS_EXTERNAL_IP;
      this.installPkgPath = pms.INSTALL_PKG_PATH;
    },
    setVersionValue(version) {
      this.displaySoftWareVersion = version;
    }

  },
  updated() {
    this.bindValidate();
  }
};
</script>
